module.exports = __webpack_public_path__ + "media/src/assets/spinner-13bcccf8cf2d0191eb68345a4817c94d.svg";